export enum cancellationReducerActionTypes {
  UPDATE_IS_OPEN = 'CANCELLATION_UPDATE_IS_OPEN',
  UPDATE_IS_LOADING = 'CANCELLATION_UPDATE_IS_LOADING',
  UPDATE_IS_CANCELED = 'CANCELLATION_UPDATE_IS_CANCELED',
}

interface CancellationUpdateIsOpenAction {
  type: cancellationReducerActionTypes.UPDATE_IS_OPEN;
  payload: boolean;
}

interface CancellationUpdateIsLoadingAction {
  type: cancellationReducerActionTypes.UPDATE_IS_LOADING;
  payload: boolean;
}

interface CancellationUpdateIsCanceledAction {
  type: cancellationReducerActionTypes.UPDATE_IS_CANCELED;
  payload: boolean;
}

export type CancellationReducerAction =
  | CancellationUpdateIsOpenAction
  | CancellationUpdateIsLoadingAction
  | CancellationUpdateIsCanceledAction;

export interface CancellationReducerState {
  isOpen: boolean;
  isLoading: boolean;
  isCanceled: boolean;
}

export const cancellationReducerInitialState: CancellationReducerState = {
  isOpen: false,
  isLoading: false,
  isCanceled: false,
};

const cancellationReducer = (
  state: CancellationReducerState,
  action: CancellationReducerAction
): CancellationReducerState => {
  switch (action.type) {
    case cancellationReducerActionTypes.UPDATE_IS_OPEN: {
      if (!state.isCanceled) {
        return {
          ...state,
          isOpen: action.payload,
        };
      }

      return state;
    }
    case cancellationReducerActionTypes.UPDATE_IS_LOADING: {
      return {
        ...state,
        isLoading: action.payload,
      };
    }
    case cancellationReducerActionTypes.UPDATE_IS_CANCELED: {
      return {
        ...state,
        isCanceled: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default cancellationReducer;
